import {DoubleSide, LineBasicMaterial, LineDashedMaterial, MeshStandardMaterial} from "three";

export const boundingBoxMaterial = new MeshStandardMaterial({color: 0xff0000, transparent: true, opacity: 0});
export const controlObjectMaterial = new MeshStandardMaterial({color: 0x38b6ff, side: DoubleSide});

export const previewMaterialRed = new MeshStandardMaterial({
    color: 0xFC1727,
    transparent: true,
    opacity: 0.8,
    depthWrite: false,
    side: DoubleSide
});

export const previewMaterial = new MeshStandardMaterial({
    color: 0x38b6ff,
    transparent: true,
    opacity: 0.8,
    depthWrite: false,
    side: DoubleSide
});

export const outerEdgeWallPreviewMaterial = new MeshStandardMaterial({
    color: 0x31a0e0,
    transparent: true,
    opacity: 0.8,
    depthWrite: false,
    side: DoubleSide
});

export const previewNotAllowedMaterial = new MeshStandardMaterial({
    color: 0x99411c,
    transparent: true,
    opacity: 0.4,
    depthWrite: false,
    side: DoubleSide
});
export const highlightMaterial = new MeshStandardMaterial({
    color: 0xff6d0a,
    side: DoubleSide,
    opacity: 0.4,
    transparent: true
});
export const roomMaterial = new MeshStandardMaterial({
    color: 0xff6d0a,
    side: DoubleSide,
    opacity: 0.4,
    transparent: true
});
export const lineMaterial = new LineBasicMaterial({color: 0x000000, side: DoubleSide});
export const dashedlineMaterial = new LineDashedMaterial({
    color: 0x000000,
    side: DoubleSide,
    linewidth: 2,
    scale: 20,
    dashSize: 3,
    gapSize: 1
});
export const measurementsMaterial = new MeshStandardMaterial({color: 0x000000, side: DoubleSide});
export const wallMaterial = new MeshStandardMaterial({color: 0xc9a265});
export const cutWallMaterial = new MeshStandardMaterial({color: 0xc46054});
export const outerWallMaterial = new MeshStandardMaterial({color: 0xc49854});
export const raehmSchwelleMaterial = new MeshStandardMaterial({color: 0xa17737});
export const supportBeamMaterial = new MeshStandardMaterial({color: 0xa17737, transparent: true, opacity: 0.8});
export const windowMaterial = new MeshStandardMaterial({color: 0xe6ffff, transparent: true, opacity: 0.4});
export const pillarMaterial = new MeshStandardMaterial({color: 0x966F33});
export const basePlateFloorMaterial = new MeshStandardMaterial({color: 0x999999});
export const plainFurnitureMaterial = new MeshStandardMaterial({color: 0xaaaaaa, side: DoubleSide});
